(() => {
  if (window.__ateProductCompareInitialized) return;
  window.__ateProductCompareInitialized = true;

  const MAX_PRODUCTS = 3;
  const selected = new Map();

  const tray = document.querySelector('[data-ate-compare-tray]');
  const countEl = document.querySelector('[data-ate-compare-count]');
  const itemsEl = document.querySelector('[data-ate-compare-items]');
  const messageEl = document.querySelector('[data-ate-compare-message]');
  const openButton = document.querySelector('[data-ate-compare-open]');
  const clearButton = document.querySelector('[data-ate-compare-clear]');
  const dialog = document.querySelector('[data-ate-compare-dialog]');
  const closeButton = document.querySelector('[data-ate-compare-close]');
  const contentEl = document.querySelector('[data-ate-compare-content]');

  if (!tray || !countEl || !itemsEl || !openButton || !dialog || !contentEl) return;

  const readProduct = (card) => ({
    id: card.dataset.compareId || '',
    title: card.dataset.compareTitle || '',
    vendor: card.dataset.compareVendor || '',
    model: card.dataset.compareModel || '',
    price: card.dataset.comparePrice || '',
    spec1Label: card.dataset.compareSpec1Label || 'Key specification',
    spec1: card.dataset.compareSpec1 || '',
    spec2Label: card.dataset.compareSpec2Label || 'Configuration',
    spec2: card.dataset.compareSpec2 || '',
    spec3Label: card.dataset.compareSpec3Label || 'Performance',
    spec3: card.dataset.compareSpec3 || '',
    powerLabel: card.dataset.comparePowerLabel || 'Power / engine',
    power: card.dataset.comparePowerValue || '',
    setupLabel: card.dataset.compareSetupLabel || 'Configuration',
    setup: card.dataset.compareSetupValue || '',
    weightLabel: card.dataset.compareWeightLabel || 'Machine weight',
    weight: card.dataset.compareWeightValue || '',
    url: card.dataset.compareUrl || '',
    image: card.dataset.compareImage || ''
  });

  const setMessage = (message = '') => {
    if (messageEl) messageEl.textContent = message;
  };

  const syncCheckboxes = () => {
    document.querySelectorAll('.ate-wc-card__compare-input').forEach((input) => {
      const card = input.closest('[data-compare-id]');
      input.checked = !!card && selected.has(card.dataset.compareId);
    });
  };

  const renderTray = () => {
    const products = [...selected.values()];
    tray.hidden = products.length === 0;
    countEl.textContent = products.length + ' of ' + MAX_PRODUCTS + ' selected';
    openButton.disabled = products.length < 2;
    openButton.textContent = products.length >= 2 ? 'Compare ' + products.length : 'Compare selected';

    itemsEl.replaceChildren();
    products.forEach((product) => {
      const chip = document.createElement('div');
      chip.className = 'ate-compare-chip';

      const label = document.createElement('span');
      label.textContent = product.model || product.title;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + product.title + ' from comparison');
      remove.textContent = '×';
      remove.addEventListener('click', () => {
        selected.delete(product.id);
        syncCheckboxes();
        setMessage('');
        renderTray();
      });

      chip.append(label, remove);
      itemsEl.append(chip);
    });
  };

  const makeCell = (tag, text, className = '') => {
    const cell = document.createElement(tag);
    if (className) cell.className = className;
    cell.textContent = text || '—';
    return cell;
  };

  const buildComparison = () => {
    const products = [...selected.values()];
    if (products.length < 2) return;

    const firstWith = (key, fallback) => {
      const item = products.find((p) => p[key]);
      return item?.[key] || fallback;
    };

    const table = document.createElement('table');
    table.className = 'ate-compare-table';

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    headRow.append(makeCell('th', 'Product'));

    products.forEach((product) => {
      const th = document.createElement('th');
      th.className = 'ate-compare-product-head';

      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'eager';
        th.append(img);
      }

      const title = document.createElement('strong');
      title.textContent = product.title;
      const vendor = document.createElement('span');
      vendor.textContent = product.vendor;
      th.append(title, vendor);
      headRow.append(th);
    });

    thead.append(headRow);
    table.append(thead);

    const tbody = document.createElement('tbody');
    const rows = [
      ['Model', 'model'],
      ['Price', 'price', 'ate-compare-price'],
      [firstWith('spec1Label', 'Key specification'), 'spec1'],
      [firstWith('spec2Label', 'Configuration'), 'spec2'],
      [firstWith('spec3Label', 'Performance'), 'spec3'],
      [firstWith('powerLabel', 'Power / engine'), 'power'],
      [firstWith('setupLabel', 'Configuration'), 'setup'],
      [firstWith('weightLabel', 'Machine weight'), 'weight']
    ];

    rows.forEach(([label, key, className]) => {
      if (!products.some((product) => product[key])) return;
      const row = document.createElement('tr');
      row.append(makeCell('th', label));
      products.forEach((product) => row.append(makeCell('td', product[key], className || '')));
      tbody.append(row);
    });

    const actionRow = document.createElement('tr');
    actionRow.append(makeCell('th', 'Details'));
    products.forEach((product) => {
      const td = document.createElement('td');
      const link = document.createElement('a');
      link.className = 'button';
      link.href = product.url;
      link.textContent = 'See Product';
      td.append(link);
      actionRow.append(td);
    });
    tbody.append(actionRow);

    table.append(tbody);
    contentEl.replaceChildren(table);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.ate-wc-card__compare-input');
    if (!input) return;

    const card = input.closest('[data-compare-id]');
    if (!card) return;

    const product = readProduct(card);

    if (input.checked) {
      if (selected.size >= MAX_PRODUCTS && !selected.has(product.id)) {
        input.checked = false;
        setMessage('You can compare up to 3 products at a time.');
        return;
      }
      selected.set(product.id, product);
    } else {
      selected.delete(product.id);
    }

    setMessage('');
    renderTray();
  });

  openButton.addEventListener('click', () => {
    if (selected.size < 2) return;
    buildComparison();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  });

  closeButton?.addEventListener('click', () => dialog.close());
  clearButton?.addEventListener('click', () => {
    selected.clear();
    syncCheckboxes();
    setMessage('');
    renderTray();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  const preselectFromUrl = () => {
    const requestedId = new URLSearchParams(window.location.search).get('compare');
    if (!requestedId || selected.has(requestedId)) return;

    const card = Array.from(document.querySelectorAll('[data-compare-id]')).find(
      (item) => item.dataset.compareId === requestedId
    );
    if (!card) return;

    const product = readProduct(card);
    if (!product.id) return;

    selected.set(product.id, product);
    const input = card.querySelector('.ate-wc-card__compare-input');
    if (input) input.checked = true;
    setMessage('This model is selected. Choose at least one more product to compare.');
    renderTray();
  };

  const observer = new MutationObserver(() => {
    syncCheckboxes();
    preselectFromUrl();
  });
  const grid = document.querySelector('.main-collection-grid');
  if (grid) observer.observe(grid, { childList: true, subtree: true });

  preselectFromUrl();
  renderTray();
})();